import { TableSettingsState, useTableSettingsStore } from './store'

const useTableSettingsStoreHelper = () => {
    const groupEnabledState = useTableSettingsStore(
        (state: TableSettingsState) => state.groupEnabled
    )
    const availableColumnsState = useTableSettingsStore(
        (state: TableSettingsState) => state.availableColumns
    )
    const groupColumnsState = useTableSettingsStore(
        (state: TableSettingsState) => state.groupColumns
    )
    const selectedColumnsState = useTableSettingsStore(
        (state: TableSettingsState) => state.selectedColumns
    )
    const pinningPropsState = useTableSettingsStore(
        (state: TableSettingsState) => state.pinningProps
    )
    const collapseColumnCheckedState = useTableSettingsStore(
        (state: TableSettingsState) => state.collapseColumnChecked
    )
    const setTableSettings = useTableSettingsStore(
        (state: TableSettingsState) => state.setTableSettings
    )
    const setPinningProps = useTableSettingsStore(
        (state: TableSettingsState) => state.setPinningProps
    )

    return {
        groupEnabledState,
        availableColumnsState,
        groupColumnsState,
        selectedColumnsState,
        pinningPropsState,
        collapseColumnCheckedState,
        setTableSettings,
        setPinningProps,
    }
}

export default useTableSettingsStoreHelper
